import { paginationSize } from '../../../constants/constants';
import {
    FETCH_SUBMITTED_FOR_VERIFICATION_START,
    FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS,
    FETCH_SUBMITTED_FOR_VERIFICATION_ERROR,
    SET_MIS_SFV_FILTER,
    SET_SFV_AUTO_NEXT_VISIT,
    SET_SFV_PAGINATION,
    VIEW_SFV_VISIT_LOADING_START,
    VIEW_SFV_VISIT_LOADING_END,
    RESET_SFV_FILTER
} from '../../actions/mis/submittedForVerificationAction';
import { SET_DEFAULT_CONFIGURATIONS } from '../../actions';

import {
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS
} from "../../actions/mis/reportViewerAction";

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    submittedForVerification: [],
    autoNextVisit: false,
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        myCasesOnly: true,
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    skippedVisits: [],
};

const submittedForVerificationReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    let searchFilter;
    switch (action.type) {
        case SET_DEFAULT_CONFIGURATIONS: {
            searchFilter = {
                ...INIT_STATE.searchFilter,
                risId: action.configurations.default_ris_id || 1,
                mipIds: action.configurations.default_mip_id ? [action.configurations.default_mip_id] : [],
                myCasesOnly: action.configurations.show_my_cases_only,
            };
            return { ...state, searchFilter };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, submittedForVerification: action.submittedForVerification };
        }
        case FETCH_SUBMITTED_FOR_VERIFICATION_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            return { ...state, error: '', message: '' };
        }
        case SET_SFV_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case SET_MIS_SFV_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }
        case SET_SFV_AUTO_NEXT_VISIT: {
            return { ...state, autoNextVisit: action.autoNextVisit };
        }

        case VIEW_SFV_VISIT_LOADING_START: {
            return { ...state, loading: true };
        }
        case VIEW_SFV_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }
        case RESET_SFV_FILTER: {
            newState = { ...state };
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default submittedForVerificationReducer;
